import React, { useContext } from 'react';
import { Header as SharedHeader } from '@spotify-internal/masthead-react';
import styled from 'styled-components';

import { MarketContext } from 'providers/market';
import { MastheadHeader } from 'utils/masthead/masthead';

interface Props {
  data?: MastheadHeader;
}

const PLAIN_DATA = {
  navigation: {
    brand: {
      href: '#',
      alt: 'Spotify',
    },
  },
};

const Container = styled.div`
  a[href='#'] {
    cursor: default;
  }

  header {
    background: transparent !important;
  }
`;

export const Header = ({ data = PLAIN_DATA }: Props) => {
  const { preferredDir } = useContext(MarketContext);

  return (
    <Container dir={preferredDir}>
      <SharedHeader {...data} fixed={false} transparent />
    </Container>
  );
};
